// move a selection to the first ("back") of its siblings

import * as d3 from 'd3'

d3.selection.prototype.moveToBack = function() {  
  return this.each(function() { 
      var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
          this.parentNode.insertBefore(this, firstChild); 
      } 
  });
};

// translate stuff

function translateString(x, y) {
  return "translate(" + x + "," + y + ")";
}

function scaleString(x, y) {
  return "scale(" + x + "," + y + ")";
}


let svgWidth, svgHeight, drawboardWidth, drawboardHeight, borderWidth, borderHeightTop, borderHeightBot;
let detectTriangle, detectCircle, detectSquare;
let borderTopRect, borderBotRect, borderRules, borderText, borderDetectorText;
let borderRulesTransformClose, borderRulesTransformOpen;
let accessGrantedText, accessDeniedText;
let currentLevel, headerFeedbackText, headerFeedbackTextShape;

export function uiInitialize(svg, drawboard, header) {
  // svgWidth = svg.attr("width");
  // svgHeight = svg.attr("height");
  svgWidth = 960; // hard coded to allow resizing viewbox
  svgHeight = 400; 
  //console.log("uiInitialize", svgWidth, svgHeight);
  
  header.append("rect")
    .attr("class", "feedback")
    .attr("y", 70)
    .attr("width", svgWidth)
    .attr("height", 80);

  headerFeedbackText = header.append("text")
    .attr("class", "feedback noselect")
    .attr("x", svgWidth/2)
    .attr("y", 125)
    .attr("opacity", 1)
    .text("Draw a ");
  
  headerFeedbackTextShape = headerFeedbackText.append("tspan")
    .attr("class", "feedback shape")
    .text("circle");
  headerFeedbackText.append("tspan")
    .text(" that will pass the ");
  headerFeedbackText.append("tspan")
    .attr("class", "feedback border")
    .text("border");
  headerFeedbackText.append("tspan")
    .text(".");
  

  let headerLevel = header.append("text")
    .attr("class", "level noselect")
    .attr("x", 10)
    .attr("y", 60)
    .text("level ");
  currentLevel = headerLevel.append("tspan")
    .attr("class", "current")
    .text("1"); 
  headerLevel.append("tspan")
    .text("/10");
  
  drawboardWidth = drawboard.node().getBBox().width;
  drawboardHeight = drawboard.node().getBBox().height;
  //console.log(drawboardWidth, drawboardHeight);
  
  borderWidth = svgWidth / 6;
  borderHeightTop = svgHeight / 2 + 60;
  borderHeightBot = svgHeight - borderHeightTop;
  
  // draw shape hint
  svg.append("polygon")
    .attr("class", "triangle outline")
    .attr("points", "70,315 330,315 200,75")
    .attr("stroke-linejoin", "round")
    .attr("opacity", 0)
    .moveToBack();

  svg.append("circle")
    .attr("class", "circle outline")
    .attr("cx", drawboardWidth / 2)
    .attr("cy", drawboardHeight / 2)
    .attr("r", drawboardWidth / 3)
    .attr("opacity", 0)
    .moveToBack();

  svg.append("rect")
    .attr("class", "square outline")
    .attr("x", 90)
    .attr("y", 90)
    .attr("rx", 5)
    .attr("ry", 5)
    .attr("width", drawboardWidth - 180)
    .attr("height", drawboardWidth - 180)
    .attr("opacity", 0)
    .moveToBack();

  // draw outside main border
  svg.append("rect")
    .attr("class", "mainspace")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", svgWidth)
    .attr("height", svgHeight)
    .moveToBack();
    
  // draw border
  let borderBot = svg.append("g")
    .attr("class", "border bot")
    .attr("transform", translateString(drawboardWidth, borderHeightTop));

  borderBotRect = borderBot.append("rect")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", borderWidth)
    .attr("height", borderHeightBot)
    .attr("shape-rendering", "crispEdges");


  let borderTop = svg.append("g")
    .attr("class", "border top")
    .attr("transform", translateString(drawboardWidth, 0));
    
  borderTopRect = borderTop.append("rect")
    .attr("width", borderWidth)
    .attr("height", borderHeightTop + 2)
    .attr("shape-rendering", "crispEdges");

  borderText = borderTop.append("text")
    .attr("class", "label")
    .attr("x", borderWidth / 2)
    .attr("y", svgHeight / 2 - 40)
    .attr("opacity", 1)
    .text("border");

  accessGrantedText = borderTop.append("g")
    .attr("opacity", 0);
  accessGrantedText.append("text")
      .attr("class", "access granted")
      .attr("x", borderWidth / 2)
      .attr("y", svgHeight / 2 - 50)
      .text("ACCESS");
  accessGrantedText.append("text")
      .attr("class", "access granted")
      .attr("x", borderWidth / 2)
      .attr("y", svgHeight / 2 + 5)
      .text("GRANTED");

  accessDeniedText = borderTop.append("g")
    .attr("opacity", 0);
  accessDeniedText.append("text")
      .attr("class", "access denied")
      .attr("x", borderWidth / 2)
      .attr("y", svgHeight / 2 - 50)
      .text("ACCESS");
  accessDeniedText.append("text")
      .attr("class", "access denied")
      .attr("x", borderWidth / 2)
      .attr("y", svgHeight / 2 + 5)
      .text("DENIED");


  borderDetectorText = borderBot.append("text")
    .attr("class", "detector")
    .attr("x", borderWidth / 2)
    .attr("y", borderHeightBot - 10)
    .attr("opacity", 0)
    .text("SHAPE DETECTOR");


  borderRulesTransformClose = translateString(5, svgHeight / 2 - 20) + scaleString(0.55, 0.55);
  borderRulesTransformOpen = translateString(5, 20) + scaleString(0.55, 0.55);

  borderRules = borderTop.append("g")
    .attr("class", "border rules")
    .attr("transform", borderRulesTransformClose);

  borderRules.append("polygon")
    .attr("class", "triangle")
    .attr("points", "20,69 86,69 53,13")
    .attr("stroke-linejoin", "round")
      .clone(true)
    .attr("class", "triangle pass");
    
  borderRules.append("circle")
    .attr("class", "circle")
    .attr("cx", 135)
    .attr("cy", 40)
    .attr("r", 30)
      .clone(true)
    .attr("class", "circle pass");

  borderRules.append("rect")
    .attr("class", "square")
    .attr("x", 193)
    .attr("y", 12)
    .attr("rx", 5)
    .attr("ry", 5)
    .attr("width", 56)
    .attr("height", 56)
      .clone(true)
    .attr("class", "square pass");

  detectTriangle = borderBot.append("polygon")
    .attr("class", "detect triangle")
    .attr("points", "30,85 130,85 80,-10")
    .attr("stroke-linejoin", "round")
    .attr("opacity", 0);

  detectCircle = borderBot.append("circle")
    .attr("class", "detect circle")
    .attr("cx", borderWidth / 2)
    .attr("cy", 38)
    .attr("r", 55)
    .attr("opacity", 0);

  detectSquare = borderBot.append("rect")
    .attr("class", "detect square")
    .attr("x", 30)
    .attr("y", -12)
    .attr("rx", 5)
    .attr("ry", 5)
    .attr("width", borderWidth - 60)
    .attr("height", borderWidth - 60)
    .attr("opacity", 0);
}


function openBorderTop() {
  borderTopRect.transition()
    .attr("height", 90)
    .delay(100)
    .duration(500);
  borderRules.transition()
    .attr("transform", borderRulesTransformOpen)
    .delay(100)
    .duration(500);
  borderText.transition()
    .attr("opacity", 0)
    .duration(500); 
};

function closeBorderTop() {
  borderTopRect.transition()
    .attr("height", borderHeightTop)
    .delay(100)
    .duration(500);
  borderRules.transition()
    .attr("transform", borderRulesTransformClose)
    .delay(100)
    .duration(500);
  borderText.transition()
    .attr("opacity", 1)
    .delay(200)
    .duration(500);
};

function openBorderBot() {
  borderDetectorText.transition()
    .attr("opacity", 1)
    // .attr("y", borderHeightBot - 10)
    .delay(100)
    .duration(500);
  borderBotRect.transition()
    .attr("y", -40)
    .attr("height", borderHeightBot + 40)
    .delay(100)
    .duration(500);  
}

function closeBorderBot() {
  borderDetectorText.transition()
    .attr("opacity", 0)
    // .attr("y", borderHeightBot)
    .delay(100)
    .duration(500);
  borderBotRect.transition()
    .attr("y", 0)
    .attr("height", borderHeightBot)
    .delay(100)
    .duration(500);  
}

function openBorder() {
  openBorderTop(); 
  openBorderBot();
}

function closeBorder() {
  closeBorderTop(); 
  closeBorderBot();
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function uiDetectShape(detectedShape, expectedShape, actualShape, drawing, svg) {
  // disable drawing by drawing a rect on top of drawboard.
  let disableDrawboard = svg.append("rect")
    .attr("x", 0)
    .attr("y", 0)
    .attr("width", drawboardWidth)
    .attr("height", drawboardHeight)
    .attr("fill", "#000")
    .attr("stroke", "none")
    .attr("opacity", 0);
    
    disableDrawboard.transition()
      .attr("opacity", 0.2);

  let pass = expectedShape == detectedShape;


  let transformScale = scaleString(100/drawboardWidth, 100/drawboardHeight);
  let transformScaleBoost = scaleString(160/drawboardWidth, 160/drawboardHeight);
  let transformDrawboardToDetect = translateString(drawboardWidth + borderWidth / 2 - 50, 105) + transformScale;
  let transformToCircle = translateString(580, -5) + transformScaleBoost;
  let transformToTriangle = translateString(745, 150) + transformScaleBoost + "rotate(-30)";
  let transformToSquare = translateString(645, 235) + transformScaleBoost;

  openBorder();
 
  await sleep(200);


  drawing.transition()
    .attr("transform", transformDrawboardToDetect)
    .duration(600);

  await sleep(600);

  let borderDetectShape;
  if (detectedShape == "triangle") 
    borderDetectShape = detectTriangle;
  if (detectedShape == "circle") 
    borderDetectShape = detectCircle;
  if (detectedShape == "square") 
    borderDetectShape = detectSquare;     
    

  let borderDetectText;
  if (pass) { // GOOD ANIM
    borderDetectText = accessGrantedText;
    borderDetectText.transition()
      .attr("opacity",1)
      .duration(300);

    borderDetectShape.transition()
      .attr("opacity",1)
      .duration(300)
      .on("end", () => {finish();});
  } else { // BAD ANIM
    borderDetectText = accessDeniedText;
    borderDetectText.transition()
        .attr("opacity",1)
        .duration(300)
      .transition()
        .attr("opacity",0)
        .duration(300)
      .transition()
        .attr("opacity",1)
        .duration(300)
      .transition()
        .attr("opacity",0)
        .duration(300)
      .transition()
        .attr("opacity",1)
        .duration(300);
  
      borderDetectShape.transition()
        .attr("opacity",1)
        .duration(300)
      .transition()
        .attr("opacity",0)
        .duration(300)
      .transition()
        .attr("opacity",1)
        .duration(300)
      .transition()
        .attr("opacity",0)
        .duration(300)
      .transition()
        .attr("opacity",1)
        .duration(300)
        .on("end", () => {finish();});
  }

  await sleep(2750); // dumb way to resync on win

  async function finish() {

    await sleep(1000);

    if (pass) {
      let transformHome;

      // send shape to its proper home
      if (actualShape == "triangle") 
        transformHome = transformToTriangle;
      if (actualShape == "circle") 
        transformHome = transformToCircle;
      if (actualShape == "square") 
        transformHome = transformToSquare;

        drawing.transition()
          .attr("transform", transformHome)
          .duration(600);

        await sleep(600);

    } else {
      // delete drawing
      drawing
          .attr("opacity", 1)
        .transition()
          .attr("opacity", 0)
          .duration(250)
          .on("end", (_, i, nodes) => {
            nodes[i].remove(); 
          });
    }

    borderDetectShape.transition()
      .attr("opacity", 0);
    borderDetectText.transition()
      .attr("opacity", 0);
    closeBorder();       

    // reenable drawing
    disableDrawboard.transition()
      .attr("opacity", 0)
      .on("end", ()=>{disableDrawboard.remove();});
      
  }
}


// function resetDrawing(drawing) {
//   let transform = translateString(0, 0) + scaleString(1, 1);
//   drawing.transition()
//     .attr("transform", transform)
//     .duration(1000);
// }

// setup function to add classes to right shapes
function disallowAll() {

  d3.selectAll(".pass")
      .transition()
    .duration(600)
    .attr("opacity", 0);

  d3.selectAll(".outline")
      .transition()
    .duration(600)
    .attr("opacity", 0);

  d3.selectAll(".border .triangle")
    .classed("allowed", false);
  d3.selectAll(".border .circle")
    .classed("allowed", false);
  d3.selectAll(".border .square")
    .classed("allowed", false);
}

// allow the desired shape
function allow(shapeDraw, shapeDetect) {

  d3.selectAll(".border ."+shapeDetect)
    .classed("allowed", true);

  d3.selectAll("."+shapeDetect+".pass")
      .transition()
    .duration(600)
    .attr("opacity", 1);
    
  d3.selectAll("."+shapeDraw+".outline")
      .transition()
    .duration(600)
    .attr("opacity", 0.5);

}

export function uiNewLevel(shapeDraw, shapeDetect, levelNum) {

  // change feedback text to new level
  headerFeedbackText.transition()
    .duration(300)
    .attr("opacity", 0)
    .on("end", () => {
      headerFeedbackTextShape.text(shapeDraw);
      headerFeedbackText.transition()
        .duration(300)
        .attr("opacity", 1);
    });
    

  disallowAll();
  allow(shapeDraw, shapeDetect); 

  currentLevel.text(levelNum+1);

}

export function uiWin(svg, path) {

  let disableDrawboard = svg.append("rect")
  .attr("x", 0)
  .attr("y", 0)
  .attr("width", drawboardWidth)
  .attr("height", drawboardHeight)
  .attr("fill", "#000")
  .attr("stroke", "none")
  .attr("opacity", 0);
  
  d3.selectAll(".border")
    .attr("opacity", 1)
    .transition()
      .duration(800)
      .attr("opacity", 0);

  d3.select(".header").insert("text")
      .attr("class", "feedback noselect")
      .attr("x", svgWidth/2-200)
      .attr("y", 120)
      .attr("opacity", 0)
      .text("?")
      .style("fill", "rgb(102, 204, 238)");

  d3.selectAll("text.feedback")
    .transition()
      .duration(500)
      .attr("opacity", 0)
      .on("end", ()=> {
        headerFeedbackText.text("")
        .append("tspan")
          .attr("fill", "#6ce")    
          .text("_______")
        .append("tspan")
          .attr("fill", "white") 
          .text(" _______ _______");
    
        d3.selectAll("text.feedback")
        .transition()
          .duration(500)
          .attr("opacity", 1);        
      });

  d3.select(".circle.outline")
    .transition()
      .duration(800)
      .ease(d3.easeElasticOut)
      .attr("transform", scaleString(0.5, 0.5) + translateString(200, 200))
      .attr("opacity", 0.1)
      .on("end", ()=> {
        d3.select(".circle.outline")
          .transition()
            .duration(300)
            .attr("opacity", 0);
      });

  svg.append("g")
    .attr("id", "w")
      .append("path") 
      .attr("d", path)
      .attr("fill", "#6ce")
      .attr("opacity", 0)
      .attr("transform", translateString(107, 5) + scaleString(1.7, 1.7))
    .transition()
      .duration(800)
      .attr("opacity", 0.5);
   

}